module.exports = __webpack_public_path__ + "static/diy_recipe_wishmas_flower-587e68179dca06877eb1cc6ed950a036.pdf";